// TenantSettingsBarContext.tsx
import { createContext, useContext, useState, ReactNode } from "react";

interface TenantSettingsState {
  tenantId?: string;
  tenantName?: string;
  show: boolean;
  open: (tenantId: string, tenantName?: string) => void;
  close: () => void;
}

const TenantSettingsBarContext = createContext<TenantSettingsState | undefined>(undefined);

export const TenantSettingsBarProvider = ({ children }: { children: ReactNode }) => {
  const [tenantId, setTenantId] = useState<string>();
  const [tenantName, setTenantName] = useState<string>();
  const [show, setShow] = useState(false);

  const open = (id: string, name?: string) => {
    setTenantId(id);
    setTenantName(name);
    setShow(true);
  };

  const close = () => {
    setTenantId(undefined);
    setTenantName(undefined);
    setShow(false);
  };

  return (
    <TenantSettingsBarContext.Provider value={{ tenantId, tenantName, show, open, close }}>
      {children}
    </TenantSettingsBarContext.Provider>
  );
};

export const useTenantSettingsBar = () => {
  const context = useContext(TenantSettingsBarContext);
  if (!context) throw new Error("useTenantSettingsBar must be used within TenantSettingsBarProvider");
  return context;
};